module.exports = __webpack_public_path__ + "img/loading.85dc8f93.svg";